import { Injectable } from '@angular/core';
declare let google;

@Injectable({
    providedIn: 'root'
})
export class UtilsServices {
    /**
     * @description Send an address | zipCode and get an array of suggestions from Google Maps.
     * @param value The object that receives a property called "address". Check the GeoCode interface
     * @returns Array Object
     */
    async getGeoCodeSuggestion(value: GeoCode): Promise<any[]> {
        let name = Object.keys(value)[0];
        try {
            return <any[]>await this.searchGoogle(name, value[name]);
        } catch (e) {
            console.log(e)
        }
    }

    /**
     * This function is triggered only if the backend don't have suggestions
     * @param name It's necessary to create a dinamic query to geoCode Google. IT'S INUSED FOR MOMENT
     * @param value Address | Zipcode
     */
    private async searchGoogle(name: string, value: string) {
        let sugg = [];
        let geocode = new google.maps.Geocoder();

        let suggGoogle = await new Promise(async (d, r) => {
            await geocode.geocode({ 'address': value }, (res, status) => {
                if (status === 'ZERO_RESULTS') return status;
                if (status === 'OK') {
                    let addressComponent = res[0].address_components
                    for (let x = 0; x < addressComponent.length; x++) {
                        let chk = addressComponent[x];
                        if (chk.types[0] == 'postal_code') {
                            sugg.push({
                                formatted: res[0].formatted_address,
                                latitude: res[0].geometry.location.lat(),
                                longitude: res[0].geometry.location.lng(),
                                zip_code: chk.long_name
                            });
                        }

                        d(sugg);
                    }
                }
            })
        });
        return suggGoogle;
    }

    addGoogleAutocompleteTo(elementId: string, country: string[] = ['US', 'CA', 'MX']): Promise<SuggestionPlace> {
        return new Promise((resolve, reject) => {
            const options = {
                strictBounds: true,
                componentRestrictions: { country },
                fields: ["formatted_address", "geometry", "name", "address_components"],
                types: ["address"]
            }
            const element = document.getElementById(elementId);
            let places = new google.maps.places.Autocomplete(element, options)
            places.addListener('place_changed', () => {
                let place = places.getPlace();

                let { lat, lng } = place.geometry.location;
                let state = place.address_components.filter(addr => addr.types.includes("administrative_area_level_1"))[0]?.short_name;
                let city = place.address_components.filter(addr => addr.types.includes("locality"))[0]?.short_name;
                let zip_code = place.address_components.filter(addr => addr.types.includes("postal_code"))[0]?.long_name;

                const latitude = lat();
                const longitude = lng();
                resolve({
                    latitude,
                    longitude,
                    address: place.name,
                    city,
                    state,
                    zip_code
                });
            })
        })
    }
}

type GeoCode = {
    [key in 'address']?: string
}
type SuggestionPlace = {
    latitude: number,
    longitude: number,
    address: string,
    city: string,
    state: string,
    zip_code: string
}
